import { Box, Typography } from '@mui/material'
import { Trans } from '@lingui/macro'
import { ReportsViewer } from './ReportsViewer'
import { Report } from '@/core/models/report.model'

interface ReportsTabContentProps {
  isLoading: boolean
  error: unknown
  reports: Report[] | undefined
}

export function ReportsTabContent({ isLoading, error, reports }: ReportsTabContentProps) {
  if (isLoading) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="body1">
          <Trans>Loading reports...</Trans>
        </Typography>
      </Box>
    )
  }

  if (error) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="body1" color="error">
          <Trans>Error loading reports. Please try again.</Trans>
        </Typography>
      </Box>
    )
  }

  if (!reports) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="body1">
          <Trans>No reports available</Trans>
        </Typography>
      </Box>
    )
  }

  return <ReportsViewer reports={reports} />
}

